export enum BOXOFFICE_STATE {
    ROOT,
    MOVIE,
    DATE,
    SYSTEM,
    SCREEN,
    SESSION
}


// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/_custom/custom.constant.ts